"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.scopedStyles = exports.globalCss = void 0;
var counter = 0;
function objectToString(selector, obj) {
    var body = Object.entries(obj)
        .map(function (_a) {
        var property = _a[0], value = _a[1];
        if (typeof value === "object")
            return "";
        var cssProperty = property.replace(/[A-Z]/g, function (c) { return "-" + c.toLowerCase(); });
        var cssValue = typeof value === "number" ? value + "px" : value;
        return cssProperty + ":" + cssValue;
    })
        .filter(function (row) { return row; })
        .join(";");
    var nested = Object.entries(obj)
        .map(function (_a) {
        var property = _a[0], value = _a[1];
        if (typeof value !== "object")
            return "";
        return objectToString(property.includes("&")
            ? property.replace(/&/g, selector)
            : "selector " + property, value);
    })
        .join("");
    return selector + "{" + body + "}" + nested;
}
function globalCss(window, css) {
    var doc = window.document;
    var s = doc.createElement("style");
    s.innerHTML = css;
    doc.head.appendChild(s);
}
exports.globalCss = globalCss;
function scopedStyles(prefix, styles, win) {
    counter += 1;
    var name = prefix + "-" + counter;
    var w = win || (typeof window === "undefined" ? undefined : window);
    if (typeof w !== "undefined") {
        var style = w.document.createElement("style");
        style.innerText = objectToString("." + name, styles);
        w.document.head.appendChild(style);
    }
    return name;
}
exports.scopedStyles = scopedStyles;
//# sourceMappingURL=index.js.map